import type { Appointment } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";
import { workOrderKeys } from "../../../work-order/api/work-order.keys";
import { auditLogKeys } from "../../../audit-log";
import { appointmentApi } from "../service";

/** Removes one field attachment. 403 when the actor is neither its uploader nor the office. */
export function useRemoveAppointmentTechnicianAttachment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      attachmentId,
      workOrderId,
    }: {
      id: number;
      attachmentId: number;
      workOrderId?: string;
    }) => {
      const { data } = await appointmentApi.removeTechnicianAttachment(id, attachmentId);
      return { appointment: data as Appointment, workOrderId };
    },
    onSuccess: ({ appointment }) => {
      queryClient.setQueryData(appointmentKeys.detail(appointment.id), (prev: Appointment | undefined) =>
        prev ? { ...prev, technicianAttachments: appointment.technicianAttachments } : prev,
      );
    },
    onSettled: (_data, _err, vars) => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      queryClient.invalidateQueries({ queryKey: workOrderKeys.all });
      if (vars?.workOrderId) {
        queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(vars.workOrderId) });
      }
    },
  });
}
